import http from './httpService';
import { apiUrl } from "../config.json";

const apiEndpoint = apiUrl + "/manufacturers"

function manufacturerUrl(id) {
    return `${apiEndpoint}/${id}`;
  }
  
  export function getManufacturers() {
    return http.get(apiEndpoint);
  }

  export function getManufacturersByAlpha(char) {
    return http.get(`${apiEndpoint}/alpha/${char}`);
  }

  export function getManufacturer(manufacturerId) {
    if(manufacturerId === undefined) return null;
    return http.get(manufacturerUrl(manufacturerId));
  }
  
  export function saveManufacturer(manufacturer) {
    if (manufacturer.manufacturer_id) {
      const body = { ...manufacturer };
      delete body.manufacturer_id;
      return http.put(manufacturerUrl(manufacturer.manufacturer_id), body);
    }
  
    return http.post(apiEndpoint, manufacturer);
  }
  
  export function deleteManufacturer(manufacturerId) {
    return http.delete(manufacturerUrl(manufacturerId));
  }
  
  export function getCountriesOfOrigin(){
    return http.get(`${apiEndpoint}/countries`);
  }

  export function getYearsActive(){
    return http.get(`${apiEndpoint}/yearsactive`);
  }

  export function getKitMolds(){
    return http.get(`${apiEndpoint}/kitmolds`);
  }

  export function getBrands(){
    return http.get(`${apiEndpoint}/brands`);
  }

  export function getList(){
    return http.get(`${apiEndpoint}/list`);
  }

  function searchUrl(queryString) {
    return `${apiEndpoint}/search?${queryString}`;
}
  export function getSearchResults(queryString) {
    const url = searchUrl(queryString);
    return http.get(url);
        
}